<template>
  <m-demo-box demo-option="audiencePropensities">
    <div slot="top">
      <m-demo-all-check />
    </div>
    <b-container fluid>
      <m-demo-select :needDemo="true"></m-demo-select>
    </b-container>
  </m-demo-box>
</template>

<script>
  import MDemoAllCheck from '@/components/demo/MDemoAllCheck'
  import MDemoBox from '@/components/demo/MDemoBox'
  import MDemoSelect from '@/components/demo/MDemoSelect'

  export default {
    components: {
      MDemoBox,
      MDemoSelect,
      MDemoAllCheck
    },
    data () {
      return {
        selectColumn: null
      }
    },
    created () {
    },
    methods: {}
  }
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/order/DemoAudiencePropensities.vue